import React from 'react';

import { LoadingSpinner } from '@trqk/components';
import {
    modalFooterHeight,
    modalFooterShimHeight,
    tableHeight,
    searchBarHeight,
} from '../../constants';

import { DetectionTracksTable } from '.';

interface DetectionTracksProps {
    detectionTracks: DetectionTrack[];
    detectionStats: DetectionStats;
    loading: boolean;
    modalOpenedAt: Maybe<number>;
    refresh: Maybe<number>;
    remove(removeModalInput: RemoveModalInput): void;
    setDetectionTracks: SetState<DetectionTrack[]>;
}

export const DetectionTracks = ({
    detectionTracks,
    detectionStats,
    loading,
    modalOpenedAt,
    refresh,
    remove,
    setDetectionTracks,
}: DetectionTracksProps): JSX.Element => (
    <div
        style={{
            height:
                tableHeight +
                modalFooterHeight +
                modalFooterShimHeight +
                searchBarHeight,
        }}
    >
        {!loading && (
            <DetectionTracksTable
                detectionTracks={detectionTracks}
                detectionStats={detectionStats}
                modalOpenedAt={modalOpenedAt}
                refresh={refresh}
                remove={remove}
                setDetectionTracks={setDetectionTracks}
            />
        )}
        {loading && (
            <div className="flex justify-center items-center h-full w-full">
                <LoadingSpinner />
            </div>
        )}
    </div>
);
